import React, { useEffect } from "react";
import {
	Grid,
	IconButton,
	InputAdornment,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TablePagination,
	TableRow,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useApi } from "../../../../common/hooks";
import { LicenceManagementService } from "../../../../api";

import LoadingOverlay from "../../../../common/components/loaders/LoadingOverlay";
import { translate } from "../../../../common/providers";
import style from "./Form.module.css";
import HeadCell from "../table/HeadCell";
import { CustomButton, icon, IconComponent } from "../../../../common/components";
import SearchInput from "../../../../common/components/text-fields/search-input/SearchInput";
import { isNonEmptyArray } from "../../../../common/utils";

export default function FormBlockedUser() {
	const licenceManagementStore = useSelector(({ context }) => context.licenceManagement);
	const [isLoading, setIsLoading] = React.useState(false);
	const [showActif, setShowActif] = React.useState(true);
	const [listBu, setListBu] = React.useState();
	const [searchValue, setValueSearch] = React.useState("");
	const [rowsPerPage, setRowsPerPage] = React.useState(25);
	const [pageDataTable, setPageDataTable] = React.useState(0);
	const { call: lockAccessUserByCompany } = useApi(LicenceManagementService.lockAccessUserByCompany);
	const { call: unlockAccessUserByCompany } = useApi(LicenceManagementService.unlockAccessUserByCompany);
	const { call: getListBUByUser } = useApi(LicenceManagementService.getListBUByUser);
	const { call: addRoleUserToBu } = useApi(LicenceManagementService.addRoleUserToBu);
	const { call: deleteRoleUserToBu } = useApi(LicenceManagementService.deleteRoleUserToBu);

	const getBodyTable = (params) => {
		setIsLoading(true);
		getListBUByUser(params)
			.then((data) => {
				setIsLoading(false);
				setListBu(data);
			})
			.catch((e) => {
				console.error(e);
				setIsLoading(false);
			});
	};
	const preparePayload = () => ({
		buName: searchValue,
		sort: "name",
		direction: "ASC",
		active: showActif,
	});

	const handleChangePage = (event, newPage) => {
		setPageDataTable(newPage);

		const payload = preparePayload();
		const params = {
			page: newPage,
			limit: rowsPerPage,
			userId: licenceManagementStore?.selectedUser?.id,
			payload,
		};

		getBodyTable(params);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(+event.target.value);
		setPageDataTable(0);

		const payload = preparePayload();
		const params = {
			page: 0,
			limit: event.target.value,
			payload,
			userId: licenceManagementStore?.selectedUser?.id,
		};
		getBodyTable(params);
	};
	const refreshList = () => {
		const payload = preparePayload();
		const params = {
			page: pageDataTable,
			limit: rowsPerPage,
			payload,
			userId: licenceManagementStore?.selectedUser?.id,
		};
		getBodyTable(params);
	};

	const handelUnlockAccessUserByCompany = (idCompany) => {
		unlockAccessUserByCompany({
			userId: licenceManagementStore?.selectedUser?.id,
			companyId: idCompany,
		})
			.then(() => {
				refreshList();
			})
			.catch(console.error);
	};

	const handeLockAccessUserByCompany = (idCompany) => {
		lockAccessUserByCompany({
			userId: licenceManagementStore?.selectedUser?.id,
			companyId: idCompany,
		})
			.then(() => {
				refreshList();
			})
			.catch(console.error);
	};

	useEffect(() => {
		refreshList();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showActif]);
	const handelAddAccessUserBu = (companyId) => {
		setIsLoading(true);
		addRoleUserToBu({
			payload: { value: licenceManagementStore.selectedUser.profil },
			userId: licenceManagementStore?.selectedUser?.id,
			companyId,
		})
			.then(() => {
				refreshList();
			})
			.finally(() => setIsLoading(false))
			.catch((e) => {
				console.error(e);
				setIsLoading(false);
			});
	};
	const handelDeleteAccessUserBu = (companyId) => {
		setIsLoading(true);
		deleteRoleUserToBu({
			payload: { value: licenceManagementStore.selectedUser.profil },
			userId: licenceManagementStore?.selectedUser?.id,
			companyId,
		})
			.then(() => {
				refreshList();
			})
			.finally(() => setIsLoading(false))
			.catch((e) => {
				console.error(e);
				setIsLoading(false);
			});
	};

	return (
		<Grid container bgcolor="white">
			{isLoading && <LoadingOverlay />}
			<Grid item md={8} p={1}>
				<SearchInput
					InputProps={{
						endAdornment: (
							<InputAdornment position="end">
								<IconButton onClick={refreshList}>
									<IconComponent color="var(--grey-400)" icon={icon.faSearch} />
								</IconButton>
							</InputAdornment>
						),
					}}
					placeholder={translate("license-management.users-search.search")}
					size="small"
					value={searchValue}
					variant="outlined"
					onChange={(e) => {
						setValueSearch(e.target.value);
						if (e.target.value === "") {
							refreshList();
						}
					}}
					onKeyDown={(event) => {
						if (event.key === "Enter") {
							setValueSearch(event.target.value);
							refreshList();
						}
					}}
				/>
			</Grid>
			<Grid container item justifyContent="flex-end" md={4} p={2}>
				<CustomButton
					startIcon={showActif ? icon.faPlus : icon.faArrowLeft}
					variant="contained"
					onClick={() => setShowActif(!showActif)}
				>
					{showActif
						? translate("license-management.view-table.territory.add")
						: translate("common:btn.back")}
				</CustomButton>
			</Grid>
			<Grid container className={style.tableContainer}>
				<Table className={style.table}>
					<TableHead className={style.tableHead}>
						<HeadCell
							hiddenSort
							cell={{ name: translate("license-management.view-table.territory") }}
							className={style.cell}
						/>
						<HeadCell
							hiddenSort
							cell={{ name: translate("common:licence-management.title.status") }}
							className={style.cellStatus}
						/>
						<TableCell className={style.cellAction} />
					</TableHead>
					<TableBody>
						{isNonEmptyArray(listBu?.contents) &&
							listBu?.contents?.map((c) => (
								<TableRow className={style.tableRow}>
									<TableCell className={`${style.tableCellRow} ${style.noBorderLeft}`}>
										{c?.companyName}
									</TableCell>
									<TableCell className={style.tableCellRow}>
										{/* eslint-disable-next-line no-nested-ternary */}
										{c?.userRole && c?.authorized === "ACTIVE"
											? translate("common:licence-management.status.allowed")
											: translate("common:licence-management.status.unAllowed") || ""}
									</TableCell>
									<TableCell className={`${style.tableCellRow} ${style.noBorderRight}`}>
										{/* eslint-disable-next-line no-nested-ternary */}
										{(c?.userRole &&
											// eslint-disable-next-line no-nested-ternary
											((showActif &&
												((c?.authorized === "ACTIVE" && (
													<CustomButton
														fullWidth
														color={(c?.authorized === "ACTIVE" && "secondary") || "primary"}
														startIcon={
															(c?.authorized === "ACTIVE" && icon.faLockOpen) ||
															icon.faLock
														}
														variant="outlined"
														onClick={() => handeLockAccessUserByCompany(c?.id)}
													>
														{translate("common:licence-management.user.btn-blocked")}
													</CustomButton>
												)) || (
													<CustomButton
														fullWidth
														color={(c?.authorized === "ACTIVE" && "secondary") || "primary"}
														startIcon={
															(c?.authorized === "ACTIVE" && icon.faLockOpen) ||
															icon.faLock
														}
														variant="outlined"
														onClick={() => handelUnlockAccessUserByCompany(c?.id)}
													>
														{translate("common:licence-management.user.btn-unblocked")}
													</CustomButton>
												))) || (
												<CustomButton
													fullWidth
													color="secondary"
													startIcon={icon.faMinus}
													variant="outlined"
													onClick={() => handelDeleteAccessUserBu(c?.id)}
												>
													{translate("common:licence-management.btn-remove")}
												</CustomButton>
											))) || (
											<CustomButton
												fullWidth
												color="primary"
												startIcon={icon.faPlus}
												variant="outlined"
												onClick={() => handelAddAccessUserBu(c?.id)}
											>
												{translate("common:btn.add")}
											</CustomButton>
										)}
									</TableCell>
								</TableRow>
							))}
					</TableBody>
				</Table>
			</Grid>
			<Grid container justifyContent="flex-end">
				<TablePagination
					component="div"
					count={listBu?.totalElements}
					labelRowsPerPage={translate("common:pagination.row-per-page")}
					page={pageDataTable}
					rowsPerPage={rowsPerPage}
					rowsPerPageOptions={[25, 50, 75]}
					onPageChange={handleChangePage}
					onRowsPerPageChange={handleChangeRowsPerPage}
				/>
			</Grid>
		</Grid>
	);
}
